export const FETCH_CAMPAIGN_INIT = 'FETCH_CAMPAIGN_INIT';
export const FETCH_CAMPAIGN_SUCCESS = 'FETCH_CAMPAIGN_SUCCESS';
export const FETCH_CAMPAIGN_ERROR = 'FETCH_CAMPAIGN_ERROR';
